export default "__VITE_ASSET__D8wYr8M2__"